import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ActiveSectionsService } from 'src/app/core/services/active-sections.service';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { CommonService } from 'src/app/core/services/common.service';
import { FileService } from 'src/app/core/services/file.service';
import { GameService } from 'src/app/core/services/games.service';
import { MemberService, MemberSituationEnum } from 'src/app/core/services/member.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { WaveService } from 'src/app/core/services/wave.service';
import { SelectModel } from 'src/app/shared/components/app-select-input/app-select-input.component';
import { PlanDependentCardComponent } from 'src/app/shared/components/plan-dependent-card/plan-dependent-card.component';
import { MemberShipCardsDependentsModel } from 'src/app/shared/models/memberModel';
import { CepPipe } from 'src/app/shared/pipe/cep.pipe';
import { AppFormModalComponent } from "src/app/shared/components/app-form-modal/app-form-modal.component";
import { AppButtonComponent } from "src/app/shared/components/app-button/app-button.component";
import { CommonModule } from '@angular/common';
import { AppChoosePaymentModalComponent } from "src/app/shared/components/app-choose-payment-modal/app-choose-payment-modal.component";
import { InvoiceService } from 'src/app/core/services/invoice.service';
import { UserService } from 'src/app/core/services/user.service';
import { UserModel } from 'src/app/shared/models/userModel';
import { TermsService } from 'src/app/core/services/terms.service';
import { AppModalComponent } from "src/app/shared/components/app-modal/app-modal.component";
import { AppModalChangeCheckinComponent } from "src/app/shared/components/app-modal-change-checkin/app-modal-change-checkin.component";
import { AppConfirmModalComponent } from "src/app/shared/components/app-confirm-modal/app-confirm-modal.component";
import { PhonePipe } from 'src/app/shared/pipe/phone.pipe';
import { ReplaceTextPipe } from 'src/app/shared/pipe/replace-text.pipe';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-dashboard-dependente',
  standalone: true,
  imports: [
    PlanDependentCardComponent,
    AppFormModalComponent,
    AppButtonComponent,
    CommonModule,
    AppChoosePaymentModalComponent,
    AppModalComponent,
    AppModalChangeCheckinComponent,
    AppConfirmModalComponent,
    PhonePipe,
    ReplaceTextPipe
  ],
  templateUrl: './dashboard-dependente.component.html',
  styleUrl: './dashboard-dependente.component.scss'
})
export class DashboardDependenteComponent implements OnInit {

  user: UserModel;
  dependentData: any;
  dependenteId: any;

  memberData: any;
  dependentMemberData: any;
  plan: any;
  cepPipe = new CepPipe();
  memberShipCard: MemberShipCardsDependentsModel | null;
  memberSeatNumber: any;
  memberPlanId: any;
  isActiveCheckins: boolean = false;
  isAtLeast12: boolean = true;
  isSenior: boolean = false;
  showDashboard = true;
  showContinuousMonth = localStorage.getItem('showContinuousMonth') === 'true';
  isSecondaryPlan: boolean = localStorage.getItem('isSecondaryPlan') === 'true';
  public styles: { [key: string]: string };
  carteirinhaImg = localStorage.getItem('imageLogo');
  virtualCard = localStorage.getItem('virtualCard');

  checkinButtonOptions = {
    buttonText: 'Realizar Check-in',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm btn-primary fs-xsmall',
    fontSize: 12,
  };

  btnUpdateDataOptions = {
    buttonText: 'Atualizar Dados',
    borderRadius: '25px',
    buttonSize: 'btn btn-sm fs-xsmall btn-primary',
    fontSize: 12,
  };

  //card checkin
  showDiv = false;
  ingressosCheckIn: any[] = [];
  nextGame: any[] = [];
  checkinsHistory: any = [];
  limitCheckin: any;
  checkinSelected: any;
  selectInputOptionsModal: SelectModel[] = [];
  memberDependents: any;
  selectControlModal: FormControl = new FormControl();
  teamLogo: string = '';
  guestSelect: any;
  substituteSelect: any;
  linkModalConfirm: string = '';
  pendentTicket: any;
  showIndicators: boolean = false;
  paymentModalData: any;

  termsModalBodyMessage: string = '';
  updateMemberModalBodyMessage: string = '';

  partners: any;
  experiences: any;
  secondaryPlanId = JSON.parse(
    localStorage.getItem('secondaryPlanDetail') as string
  )?.planId;

  width!: any;

  resizeSubscription!: Subscription;

  constructor(
    private userService: UserService,
    private termsService: TermsService,
    private router: Router,
    private modalService: ModalService,
    private memberService: MemberService,
    public commonService: CommonService,
    private activeSectionsService: ActiveSectionsService,
    private alertService: AlertService,
    private waveService: WaveService,
    private cdr: ChangeDetectorRef,
    private fileService: FileService,
    private gameService: GameService,
    private invoiceService: InvoiceService,
    private authService: AuthService
  ) {
    this.user = this.userService.currentUserValue as UserModel;
    this.dependenteId = localStorage.getItem('dependenteId') as string;
  }

  ngOnInit(): void {
    this.styles = {
      '--primaryColor': localStorage.getItem('primaryColor') as string,
    };
    const stringContinuousMonth = localStorage.getItem(
      'showContinuousMonth'
    ) as string;
    this.showContinuousMonth = stringContinuousMonth === 'true';

    this.checkUserData();
  }

  private checkUserData(): void {
    const hasIncompleteData =
      !this.user?.addresses?.length ||
      !this.user?.emails?.length ||
      !this.user?.birthDate;

    if (hasIncompleteData) {
      this.showUpdateDataModal();
    } else {
      this.getDependenteDashboardData();
    }
  }

  onUpdateDataModalConfirm(): void {
    this.router.navigate(['/dados-de-socio']);
  }

  goToPartnerData() {
    this.router.navigate(['/dados-de-socio']);
  }

  getAddress() {
    if (this?.dependentMemberData?.addresses[0]) {
      let address = this?.dependentMemberData?.addresses[0];
      return `${address?.area},  ${address?.number != null ? address?.number : 'S/N'
        }, ${address?.complement}, ${address?.neighborhood}, ${address?.cityName
        } - ${address?.stateName},  CEP: ${this.cepPipe.transform(
          address?.zipCode
        )} `;
    } else {
      return '-';
    }
  }

  showUpdateDataModal() {
    this.termsService.getTerms().subscribe(() => {
      this.updateMemberModalBodyMessage = "Verificamos que o seu cadastro possui pendências nos dados e precisamos que o atualize para que continue navegando!";
      this.modalService.open('updateDataModal');
    });
  }

  ngAfterViewInit(): void {
    this.getLogo();
  }

  // card checkin

  getAdversaryLogo(ingresso: any) {
    return this.fileService.getDocDownloadUrl(
      ingresso.waveGame.adversary.document.id
    );
  }

  getAdversaryLogo2(ingresso: any) {
    return this.fileService.getDocDownloadUrl(ingresso.adversary.document.id);
  }

  getLogo() {
    this.gameService.getNextMatches().subscribe({
      next: (response: any) => {
        let nextMatchesResponse = response;
        this.teamLogo = this.commonService.getImageStr(
          nextMatchesResponse.logo.id
        );
      },
      error: (error) => {
        console.error('Error: ', error);
      },
    });
  }

  async openCheckInModal(event: any): Promise<void> {
    const wave = this.ingressosCheckIn.find(w => w.id === event);

    if (this.plan.member.allowCheckin === false) {
      if ((!wave.isAvaliableNoDocsMinors && !this.isAtLeast12) || (!wave.isAvaliableNoDocsSeniors && this.isSenior) || (!this.isSenior && this.isAtLeast12 && this.plan.member.allowCheckin === false)) {
        this.alertService.showAlert(
          AlertType.WARNING,
          'Você está com pendência de documentos ou com check-in bloqueado. Entre em contato com a equipe de atendimento.'
        );
        return;
      }
    }

    try {
      const result = await this.waveService
        .getCheckinsRealizados(event, this.dependentData.holderId)
        .toPromise();

      this.checkinsHistory = (result ?? []).filter(item => item.memberDependentId !== null && item.memberDependentId !== undefined);
      this.limitCheckin = await this.waveService
        .getLimitByMemberPlan(this.plan.id)
        .toPromise();
    } catch (error) {
      console.error('Error:', error);
    }
    this.checkinSelected = event;
    this.modalService.open('modalCheckinTicket');
  }

  onModalFormConfirm(event: any) {
    if (event.isDependent) {
      const dependentSelect = this.dependentData;

      const missingFields = this.validDependent(dependentSelect);
      if (missingFields.length > 0) {
        this.alertService.showAlert(
          AlertType.WARNING,
          `Dependente com dados incompletos. Campos obrigatórios não preenchidos: ${missingFields}.`
        );
        return;
      }
    }

    if (event.checkinTax) {
      this.invoiceService.createCheckinTaxInvoice(this.plan.id, event.checkinTax.id).subscribe({
        next: (res) => {
          if (res.invoicePaymentStatus !== '7859ffd3-9390-4d25-89a6-8f27533bb37e') { // Pago
            setTimeout(() => {
              this.paymentModalData = { invoice: res, checkin: event };
              this.modalService.open('modalChoosePayment');
            }, 400);
          } else {
            this.onModalCheckinConfirm(event);
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.alertService.showAlert(
            AlertType.WARNING,
            `Não foi possível gerar a fatura da taxa de substituição. Tente novamente.`
          );
        }
      });
    }
    else {
      this.onModalCheckinConfirm(event);
    }
  }

  async onModalCheckinConfirm(event: any): Promise<void> {
    const waveSelect = this.ingressosCheckIn.find((i: any) => i.id === this.checkinSelected);

    let dependentSelect: any;
    if (event.isDependent) {
      dependentSelect = this.dependentData;
    }

    if (waveSelect?.waveGame?.ticketsApiType?.id === '2649821c-02d2-407e-9cf5-0a1741a9ec37') {
      this.waveService.verifyFacialStatusImply(dependentSelect?.cpf).subscribe({
        next: (res: any) => {
          if (res.error == null && res.result.code === 20000) {

            let checkinImplyPayload: any = {
              memberId: this.plan.member.id,
              memberName: dependentSelect?.name,
              memberDocument: dependentSelect?.cpf,
              eventId: waveSelect.waveGame.event,
              ticketId: event.ticketSelected,
              code: dependentSelect?.membershipCard?.cardNumber
            }

            let isUpdate = this.validIsUpdate(event, this?.checkinsHistory);

            if (isUpdate) {

              let jaExiste = this.validJaExiste(event, this?.checkinsHistory);

              if (jaExiste) {
                this.alertService.showAlert(
                  AlertType.WARNING,
                  `Já existe um checkin gerado para este usuário nesse jogo!`
                );
              } else {
                this.waveService.updateCheckinImply(checkinImplyPayload).subscribe({
                  next: (res: any) => {
                    if (res.error != null) {
                      if (res.error.code === 20006) {
                        this.alertService.showAlert(
                          AlertType.WARNING,
                          `Já existe um checkin gerado para este usuário!`
                        );
                      } else {
                        console.error('Error: ', res.error);
                        this.alertService.showAlert(
                          AlertType.WARNING,
                          `Não foi possível realizar o checkin, tente novamente mais tarde!`
                        );
                      }
                    } else {
                      let parsed = JSON.parse(res.result);
                      let orderId = parsed.key;
                      let checkinPayload: any = {
                        waveId: this.checkinSelected,
                        ticketId: waveSelect.waveTicketsDependent.find(
                          (i: any) => i.ticketId === event.ticketSelected
                        ).id,
                        memberPlanId: this.plan.id,
                        memberDependentId: event.isDependent ? event.clientSelected : '',
                        guestCheckinId: '',
                        substituteCheckinId: '',
                        ticketLink: window.location.origin + '/check-in/detalhe/' + orderId,
                        ticketValue: waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected).ticketValue,
                        ticketCode: dependentSelect?.membershipCard?.cardNumber,
                        orderId: orderId,
                        checkinTaxId: event?.checkinTax?.id || null
                      };

                      this.waveService.criarCheckin(checkinPayload).subscribe((data: any) => {
                        this.alertService.showAlert(
                          AlertType.SUCCESS,
                          'Checkin realizado com sucesso.'
                        );
                        window.location.reload();
                      });

                    }
                  }, error: (error) => {
                    console.error('Error: ', error);
                  },
                })
              }
            } else {
              this.waveService.realizarCheckinImply(checkinImplyPayload).subscribe({
                next: (res: any) => {
                  if (res.error != null) {
                    if (res.error.code === 20006) {
                      this.alertService.showAlert(
                        AlertType.WARNING,
                        `Já existe um checkin gerado para este usuário!`
                      );
                    } else {
                      console.error('Error: ', res.error);
                      this.alertService.showAlert(
                        AlertType.WARNING,
                        `Não foi possível realizar o checkin, tente novamente mais tarde!`
                      );
                    }

                  } else {

                    let parsed = JSON.parse(res.result);
                    let orderId = parsed.key;
                    let checkinPayload: any = {
                      waveId: this.checkinSelected,
                      ticketId: waveSelect.waveTicketsDependent.find(
                        (i: any) => i.ticketId === event.ticketSelected
                      ).id,
                      memberPlanId: this.plan.id,
                      memberDependentId: event.isDependent ? event.clientSelected : '',
                      guestCheckinId: '',
                      substituteCheckinId: '',
                      ticketLink: window.location.origin + '/check-in/detalhe/' + orderId,
                      ticketValue: waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected).ticketValue,
                      ticketCode: dependentSelect?.membershipCard?.cardNumber,
                      orderId: orderId,
                      checkinTaxId: event?.checkinTax?.id || null
                    };

                    this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
                      this.alertService.showAlert(
                        AlertType.SUCCESS,
                        'Checkin realizado com sucesso.'
                      );
                      window.location.reload();
                    });

                  }
                }, error: (error) => {
                  console.error('Error: ', error);
                },
              })
            }

          } else if (res.error == null && res.result.code === 20002) {
            this.alertService.showAlert(
              AlertType.INFO,
              `Seu cadastro de Facial está em análise, aguarde alguns instantes até que seja validado e tente novamente mais tarde`
            );
          } else {
            this.alertService.showAlert(
              AlertType.INFO,
              `Status da Facial: ${res.error != null ? 'Facial não cadastrada' : res.result?.msg}. Você será redirecionado para realizar a validação facial!`
            );

            let setPessoaPayload: any = {
              de_para: dependentSelect?.cpf,
              nome: dependentSelect?.name,
              cpf: dependentSelect?.cpf,
              email: dependentSelect?.email,
              dt_nascimento: dependentSelect?.birthDate,
              informacoes_extras: {
                redirect_url: window.location.href
              }
            }

            this.waveService.registerFacialImply(setPessoaPayload).subscribe({
              next: (res: any) => {
                if (res.error != null) {
                  this.alertService.showAlert(
                    AlertType.WARNING,
                    `Não foi possível cadastrar a facial, tente novamente mais tarde!`
                  );
                } else {
                  let token = res.result;
                  let urlFacial = `https://ahmangueirao.eleventickets.com/OAuth2/external?token=${token}&url=aHR0cHM6Ly9haG1hbmd1ZWlyYW8uZWxldmVudGlja2V0cy5jb20vRmFjaWFsUmVjb2duaXRpb24%3D`;
                  window.location.href = urlFacial;
                }
              }, error: (error) => {
                console.error('Error: ', error);
              },
            })

          }

        }, error: (error) => {
          console.error('Error: ', error);
        },

      })


    } else {
      let ticketPayload: any = {
        customer: {
          name: dependentSelect?.name,
          doc: dependentSelect?.cpf,
          email: dependentSelect?.email,
          mifare: dependentSelect?.membershipCard?.cardNumber || '',
          phones: [dependentSelect.phone ? dependentSelect.phone : this.plan.member.memberPhoneTO.number],
        },
        tickets: [
          {
            ticketId: event.ticketSelected,
            ticketValue: waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue || 0, // Fallback para 0 caso o valor não seja encontrado
            customer: {
              name: dependentSelect?.name,
              doc: dependentSelect?.cpf,
              email: dependentSelect?.email,
              mifare: dependentSelect?.membershipCard?.cardNumber,
              phones: [dependentSelect.phone ? dependentSelect.phone : this.plan.member.memberPhoneTO.number],
            },
          },
        ],
      };

      this.waveService.realizarCheckin(ticketPayload).subscribe({
        next: (res: any) => {
          if (res?.mandatoryFace && event?.isGuest) {
            this.linkModalConfirm = res?.link;
            this.modalService.open('modalConfirm');
          }

          if (res.orderStatus && res?.orderStatus === 'Initial') {
            this.pendentTicket = res;
            this.modalService.open('modalChangeCheckin');
          } else if (res?.mandatoryFace) {
            const newTab = window.open('', '_blank');
            if (newTab) {
              newTab.location.href = res?.link; // Define a URL da aba já aberta
            } else {
              window.location.href = res.link;
            }
          } else {
            let checkinPayload: any = {
              waveId: this.checkinSelected,
              ticketId: waveSelect.waveTicketsDependent.find(
                (i: any) => i.ticketId === event.ticketSelected
              )?.id,
              memberPlanId: this.plan.id,
              memberDependentId: event.isDependent ? event.clientSelected : '',
              guestCheckinId: '',
              substituteCheckinId: '',
              ticketLink: res?.link || '',
              ticketValue: waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue || 0,
              ticketCode: res?.codes[0] || '',
              orderId: res.orderId,
              checkinTaxId: event?.checkinTax?.id || null
            };
            this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
              this.alertService.showAlert(
                AlertType.SUCCESS,
                'Checkin realizado com sucesso.'
              );
              const newTab = window.open('', '_blank');
              if (newTab) {
                newTab.location.href = res.link;
              } else {
                window.location.href = res.link;
              }
              window.location.reload();
            });
          }
        },
        error: (error) => {
          console.error('Error: ', error);
        },
      });
    }
  }

  validJaExiste(event: any, history: any) {
    if (!history) {
      return false;
    } else
      if (event.isDependent && history.find((i: any) => i.memberDependentId != null && i.checkinStatus == 'Realizado')) {
        return true;
      }
      else {
        return false;
      }
  }

  validIsUpdate(event: any, history: any) {
    if (!history) {
      return false;
    } else
      if (event.isGuest && history.find((i: any) => i.memberGuestId != null && i.checkinStatus == 'Cancelado')) {
        return true;
      }
      else {
        return false;
      }
  }

  validDependent(dependent: any): string {
    const missingFields = [];

    if (!dependent?.name) {
      missingFields.push('Nome');
    }
    if (!dependent?.cpf) {
      missingFields.push('CPF');
    }
    if (!dependent?.email) {
      missingFields.push('E-mail');
    }
    if (!dependent?.membershipCard?.cardNumber) {
      missingFields.push('Carteirinha');
    }
    if (!dependent?.birthDate) {
      missingFields.push('Data de Nascimento');
    }

    return missingFields.join(', ');
  }

  getDependentPlanDashboardData() {
    this.memberService
      .getMemberPlanDashboardData(this.dependentData.holderId, false)
      .subscribe({
        next: (res) => {
          this.plan = res;
          this.memberPlanId = res.id;
          if (this.plan) {
            this.getNextActivesWaves();
          }
          this.showDashboard = true;
          this.cdr.detectChanges();
        },
        error: (e) => {
          console.error('Error:', e);
          this.alertService.showAlert(AlertType.WARNING, e.error.message);
        },
      });
  }

  getNextActivesWaves() {
    this.waveService.getNextActivesWaves(this.plan?.plan?.id).subscribe(
      (data) => {
        if (data.length > 0) {
          this.ingressosCheckIn = data;
          this.showIndicators = this.ingressosCheckIn.length > 1;
        } else {
          this.waveService.getNextGame().subscribe((res) => {
            if (res.length > 0) {
              this.nextGame = res;
              this.showIndicators = this.nextGame.length > 1;
            }
          });
        }
      },
      (error) => {
        this.waveService.getNextGame().subscribe((res) => {
          if (res.length > 0) {
            this.nextGame = res;
            this.showIndicators = this.nextGame.length > 1;
          }
        });
      }
    );
  }

  getDependenteDashboardData() {
    this.memberService.getDependenteDashboardData(this.dependenteId).subscribe((res) => {
      this.dependentData = res;

      if (res.birthDate) {
        const birth = new Date(res.birthDate);
        const now = new Date();
        let age = now.getFullYear() - birth.getFullYear();
        const m = now.getMonth() - birth.getMonth();
        if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
          age--;
        }
        this.isAtLeast12 = age >= 12;
        this.isSenior = age >= 65;
      }

      if (res.membershipCard) {
        this.memberShipCard = res.membershipCard;
      }

      let option: SelectModel = {
        code: res.id,
        name: `${res.name} (Dependente)`,
      };
      this.selectInputOptionsModal.push(option);
      this.getDependentPlanDashboardData();
      this.getMemberDashboardData();
      this.getDependentMemberData();
    });
  }

  getMemberDashboardData() {
    this.memberService.getMemberDashboardData(this.dependentData.holderId).subscribe((res) => {
      this.memberData = res;

      this.getActiveSections();
    });
  }

  getDependentMemberData() {
    this.memberService.getMemberDashboardData(this.user.id).subscribe((res) => {
      this.dependentMemberData = res;
    });
  }

  getActiveSections() {
    this.activeSectionsService.getActiveSections().subscribe({
      next: (res: any) => {
        this.isActiveCheckins =
          (this.isSecondaryPlan ||
            (res.sections?.ingressos && this.memberData?.memberSituation?.id === this.memberSituationEnum.Adimplente)
          ) ||
          false;
      },
    });
  }

  showCarteirinha() {
    this.modalService.open('membershipCardModal');
  }

  get memberSituationEnum() {
    return MemberSituationEnum;
  }
}
